// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { AllocationFactory } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/AllocationFactory';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useAllocationFactories: (
  operator: string,
  registrar: string,
) => UseQueryResult<TemplateContract<AllocationFactory>[], string> = (operator, registrar) => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOptions({
    queryKey: ['queryAllocationFactory', operator, registrar],
    queryFn: async (_, options) => {
      return ledgerApi.queryAllocationFactory(options, operator, registrar);
    },
  });
};

export default useAllocationFactories;
